import React, { Component } from 'react';
import { connectRefinementList } from 'react-instantsearch-dom'

const EventTypeFilters = connectRefinementList(({
    refine,
    items,
}) => {
    return <EventRefinement refine={refine} items={items} />
})

class EventRefinement extends Component {

    constructor(props) {
        super(props)
        this.refine = props.refine
        this.state = {
            items: []
        }
    }

    static getDerivedStateFromProps(props, state) {
    // Only set items state once for initial filter
        if (state.items.length === 0) {
            return {
                items: props.items
            }
        } else {
            const newState = props.items
            return {
                items: newState
            }
        }
    }

    render() {
        return (
            this.state.items.map(type => (
                <div key={type.label} className="c-event-filter-set-types__type">
                    <button className={type.isRefined ? 'active' : ''}
                        onClick={()=>{
                            this.refine(type.value)
                        }}>{type.label}</button>
                </div>
            ))
        );
    }
}

export default EventTypeFilters



// WEBPACK FOOTER //
// ./src/whatson/components/EventTypeFilters.js